import { Component, Input, OnInit } from "@angular/core";
import { EditUserViewModel } from "../../../ViewModels/EditUserViewModel";

@Component({
  selector: "evrideo-user-action-permissions",
  templateUrl: "./user-action-permissions.component.html",
  styleUrls: ["./user-action-permissions.component.scss"],
})
export class UserActionPermissionsComponent implements OnInit {
  @Input()
  userVM: EditUserViewModel;

  constructor() {}

  ngOnInit() {}
}
